import { borderWidthVars, radiusVars } from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';
import { style } from '@vanilla-extract/css';

const MAP_HEIGHT_PX = 320;

export const mapClass = style({
  width: '100%',
  height: MAP_HEIGHT_PX,
  overflow: 'hidden',
  border: `${borderWidthVars.xs} solid ${semanticTokenVars.border.neutral.default.subtle}`,
  borderRadius: radiusVars.md,
  backgroundColor: semanticTokenVars.surface.background.neutral.default.base,
});
